export default __webpack_public_path__ + "static/media/Arrow.5f4f7ae0.svg";